'use client'

import * as UI from '../footer.styled'
import React from 'react'

import iconYtb from '@/src/shared/assets/media/icon-utb.svg'
import iconVk from '@/src/shared/assets/media/icon-vk.svg'
import {Image} from '@/src/shared/ui/image'

interface FooterSocialProps {
  readonly socials: LayoutData['footer']['socials']
}

export const FooterSocial: React.FC<FooterSocialProps> = ({socials}) => {
  return (
    <UI.Social>
      {socials.vk && (
        <a href={socials.vk} target="_blank" rel="noreferrer">
          <Image src={iconVk} alt="" sizes="100vw" width={20} height={20} />
        </a>
      )}

      {socials.youtube && (
        <a href={socials.youtube} target="_blank" rel="noreferrer">
          <Image src={iconYtb} alt="" sizes="100vw" width={20} height={20} />
        </a>
      )}
    </UI.Social>
  )
}
